import { selectKeyPath } from '@odc/odbelt'
import React from 'react'
import { ODWebUtils } from '../../../../../utils'
export function ODFileRow(props) {
  var value = props.value,
    keyPath = props.keyPath,
    render = props.render
  var data = keyPath ? selectKeyPath(keyPath)(value, null) : value
  return React.createElement(React.Fragment, null, render(data, ODWebUtils.isFileObject(data)))
}
//# sourceMappingURL=ODFileRow.js.map
